module.exports = __webpack_public_path__ + "img/2921619-09-0.b19b08c4.png";